'use client';

import { Children, cloneElement, FC, ReactNode, isValidElement } from 'react';
import NavbarLoginButton from './NavbarLoginButton';
import NavbarLogo from './NavbarLogo';
import NavbarMenuButton from './NavbarMenuButton';
import NavbarMenuContent from './NavbarMenuContent';
import NavbarMenuWrapper from './NavbarMenuWrapper';
import NavbarMenuAnchor from './NavbarMenuAnchor';

type Props = {
	children?: ReactNode;
};

const NavbarBase: FC<Props> = ({ children }) => {
	// Clonar children para adicionar prop mobile=true para versão mobile
	const mobileChildren = Children.map(children, (child) => {
		if (isValidElement(child)) {
			return cloneElement(child, { ...child.props, mobile: true });
		}
		return child;
	});

	return (
		<header className="h-[66px] lg:h-[86px] bg-white shadow-md relative">
			<nav className="w-11/12 mx-auto h-full flex items-center md:gap-4 lg:gap-12">
				<NavbarLogo />

				<div className="hidden ml-auto md:flex h-full">{children}</div>

				<div className="flex items-center gap-6 ml-auto md:ml-0">
					{/* TODO: removido até implementado */}
					<NavbarLoginButton />

					<NavbarMenuWrapper>
						<NavbarMenuButton />

						<NavbarMenuAnchor />

						<NavbarMenuContent>{mobileChildren}</NavbarMenuContent>
					</NavbarMenuWrapper>
				</div>
			</nav>
		</header>
	);
};

export default NavbarBase;
